<template lang="html">
  <error-page-layout
    icon="refresh"
    error-type="Atualização no sistema"
    color-type="success"
    title="3, 2, 1, decolar!"
    first-message="Estamos implementando uma atualização no sistema."
    second-message="Retorne após a"
    focus-message="previsão de conclusão:"
    under-message="12/02/2018 - 20h00"
    image-name="update.png"
  />
</template>

<script>
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'

export default {
  components: {
    ErrorPageLayout,
  },
  created() {
    this.checkForMaintenance()
  },
  methods: {
    checkForMaintenance() {
      this.$store.dispatch('getStates', ['getLastUpdate']).then(() => {
        this.$router.push('/home').catch(() => {})
      })
    },
  },
}
</script>
